import React from 'react';
import { useSelector } from 'react-redux';

import { getCustomers } from '../../store/redux';

import classes from './CustomerList.module.css';

const empty = ( value ) => ( ! value || value.trim().length === 0 );

const simpleText = ( text ) => {
    if ( empty( text ) ) {
        return '';
    }

    return text
        .normalize( 'NFD' )                      // Decompose characters
        .replace( /([\u0300-\u036f]|\s|[-])/g, '' ); // Remove diacritics and spaces
};

const searchPattern = ( text ) => {
    if ( empty( text ) ) {
        return null;
    }
    return new RegExp( simpleText( text ), 'ig' );
}

const CustomerList = ( { name, phone, email, selected, onSelect } ) => {
    const customers = useSelector( getCustomers );

    const selectCustomer = ( e ) => {
        e.stopPropagation();
        const div = e.target.closest( `.${ classes.Even }, .${ classes.Odd }` );
        onSelect( customers.filter( customer => customer.id === div.dataset.id )[ 0 ] );
    }

    const resetSelection = ( e ) => {
        e.stopPropagation();
        onSelect( { name: '', phone: '', email: '' } );
    }

    const searchName  = searchPattern( name );
    const searchPhone = searchPattern( phone );
    const searchEmail = searchPattern( email );

    const matches = ( value, searchPattern ) => {
        if ( ! searchPattern ) {
            return true;
        }
        return simpleText( value ).match( searchPattern );
    }

    const customerMatched = ( customer ) => {
        if ( empty( name ) && empty( phone ) && empty( email ) ) {
            return true;
        }

        return (
            ( ! empty( name )  && matches( customer.name,  searchName ) )  ||
            ( ! empty( phone ) && matches( customer.phone, searchPhone ) ) ||
            ( ! empty( email ) && matches( customer.email, searchEmail ) )
        ) 
    }

    let even = true;

    const matched = customers
        .filter( 
            customer => (
                ! customer.isAdmin &&
                (
                    ( selected && customer.id === selected.id ) ||
                    customerMatched( customer )
                )
            )
        )
        .map( customer => {
            even = ! even;
            return (
                <div key={ customer.id } className={ even ? classes.Even : classes.Odd }
                    onClick={ selectCustomer } data-id={ customer.id }
                >
                    <div>{ customer.name } - { customer.phone }</div>
                    <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ customer.email }</div>
                </div>
            ) 
        } );
    
    return (
        <div className={ classes.List } >
            <div className={ classes.Reset } onClick={ resetSelection } >Reset Customer</div>
            { matched }
        </div>
    );
}

export default CustomerList;